module.exports = __webpack_public_path__ + "static/media/icon-circle_tick2.d923103d.svg";